import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";

import EventEmitter from "./EventEmitter";
import * as THREE from "three";

export default class Resources extends EventEmitter
{
    constructor(sources)
    {
        super()

        //Options
        this.sources = sources

        //Setup
        this.items = {}
        this.loaded = 0
        this.toLoad = this.sources.length

        this.progress = Math.floor((this.loaded / this.toLoad) * 100);

        this.setLoaders()
        this.StartLoading()
    }

    setLoaders()
    {
        this.loaders = {}

        this.loaders.gltfLoader = new GLTFLoader()
        this.loaders.textureLoader = new THREE.TextureLoader()
    }

    StartLoading()
    {
        for(const source of this.sources)
        {
            if(source.type == 'gltfModel')
            {
                this.loaders.gltfLoader.load(
                    source.path,
                    (file) =>
                    {
                        this.sourceLoaded(source, file)
                    }
                 )
            }
            else if(source.type == 'texture')
            {
                this.loaders.textureLoader.load(
                    source.path,
                    (file) =>
                    {
                        this.sourceLoaded(source, file)
                    }
                 )
            }
            else if (source.type == 'music') 
            {
                this.audio = new Audio(source.path);
                this.audio.load(); 
                this.audio.addEventListener('canplaythrough', () => {
                    this.sourceLoaded(source, this.audio);
                });
            }
        }
    }

    sourceLoaded(source, file)
    {
        this.items[source.name] = file
        this.loaded++
        
        this.progress = Math.floor((this.loaded / this.toLoad) * 100);
        this.trigger("progress");

        if(this.loaded == this.toLoad){
            this.trigger("loaded")
        }
    }
}